<template>
  <div class="batch-drop-down">
    <drop-down
      v-if="disabled"
      class="dropdown dropdown-disable"
      title="批量操作"
      @select="handle"
    />
    <drop-down
      v-else
      class="dropdown"
      title="批量操作"
      :data="batchData"
      @select="handle"
    />
  </div>
</template>

<script>
import DropDown from "@/components/dropDown/index";

export default {
  components: {
    DropDown,
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => true,
    },
    batchData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handle(item) {
      this.$emit("batchDeal", item.way);
    },
  },
};
</script>

<style lang="scss" scoped>
.batch-drop-down {
  display: inline-block;
  margin-right: 15px;
}
</style>
